import React, { Component } from "react";

import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { Creators as ReasonsActions } from "store/ducks/reasons";

import { Validate } from "common";
import { Page, Breadcrumbs } from "components";
import { Form } from "pages/Reasons/components";

class Create extends Component {
  state = {
    data: {
      title: "",
      description: "",
      alias: "",
    },
    errors: {},
    breadcrumbs: [
      { name: "Home", to: "/" },
      { name: "Lista de Razões", to: "/reasons/list" },
      { name: "Adicionar Nova", to: "" },
    ],
  };

  handleChange = (data) => {
    const { errors } = this.state;

    this.setState({ data });

    Object.keys(errors).length && this.handleValidate();
  };

  handleValidate = () => {
    const { data } = this.state;

    const rules = {
      title: {
        required: true,
      },

      description: {
        required: true,
      },

      alias: {
        required: true,
      },
    };

    const validate = Validate(data, rules);
    this.setState({ errors: validate.errors });

    return validate.valid;
  };

  handleSave = () => {
    if (!this.handleValidate()) return null;

    const { data } = this.state;
    const { createReasonRequest } = this.props;

    createReasonRequest({
      title: data.title,
      description: data.description,
      alias: data.alias,
    });
  };

  render() {
    const { data, errors, breadcrumbs } = this.state;
    const { create } = this.props;

    return (
      <Page>
        <Breadcrumbs breadcrumbs={breadcrumbs} />

        <Form
          data={data}
          errors={errors}
          saving={create.loading}
          onChange={this.handleChange}
          onSave={this.handleSave}
        />
      </Page>
    );
  }
}

const mapState = (state) => ({
  create: state.reasons.create,
});

const mapActions = (dispatch) => bindActionCreators(ReasonsActions, dispatch);

export default connect(mapState, mapActions)(Create);
